var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Col',{staticClass:"icon-container flex-centerize",class:{ selected: _vm.isSelected },nativeOn:{"click":function($event){return _vm.onClick.apply(null, arguments)}}},[_c('v-img',{staticClass:"image-container",attrs:{"title":_vm.icon.name,"alt":_vm.icon.name,"aspect-ratio":"1/1","src":_vm.imgSrc,"width":_vm.size}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }